import {icons} from "lucide-react";

export const getIconOrRandom = (icon) => {
  if (icon) {
    return icons?.[icon];
  }
  const keys = Object.keys(icons);
  const randomIndex = Math.floor(Math.random() * keys.length);
  return icons[keys[randomIndex]];
}